import React from 'react';

import { ConnectionsListPage } from '../../shared/connections';
import { ORGANIZATION_CONNECTIONS_LIST_QUERY_KEY } from './queryKeys';

export const ConnectionsList: React.FC = () => {
  return (
    <ConnectionsListPage
      title="Connections"
      queryKeyBase={ORGANIZATION_CONNECTIONS_LIST_QUERY_KEY}
      displayTypePrefKey="OrganizationConnections"
      showOrganization={false}
      linkContext="organization"
    />
  );
};
